import { Component, OnInit } from '@angular/core';
import { BlogService } from '../../services/blog.service';
import { BlogPost } from '../../models/blogpost';
import { ActivatedRoute } from '../../../../node_modules/@angular/router';
import { forkJoin } from '../../../../node_modules/rxjs';
import { AccountService } from 'src/app/services/account.service';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-blog-article',
  templateUrl: './blog-article.component.html',
  styleUrls: ['./blog-article.component.scss']
})
export class BlogArticleComponent implements OnInit {
  public blogPost: BlogPost;
  public loading: boolean = true;
  public random: BlogPost[];
  public breadcrumbLinks=[{routerLink:'/blog', label: 'News, Views & Analysis'}];
  public thisPage:string='';
  public postId;
  public loggedIn:boolean=false;

  constructor(
    private blogService: BlogService,
    private route: ActivatedRoute,
    private _acc: AccountService,
    private _auth: AuthenticationService,
  ) {
    this._auth.loggedIn.subscribe(res=>{
      this.loggedIn=res;
    });
    this.route.params.subscribe(params => {
      this.postId = +params['id'];
      this.getPost(this.postId);
   });


  }

  ngOnInit() {
  }

  public claimCPD(){
    this.blogService.logPostCDP(this.postId).subscribe(
      res=>{
        this.getPost(this.postId);
        this._acc.updatePoints();
      }
    );
  }

  private getPost(post_id){
    forkJoin(this.blogService.getLatest(4),this.blogService.getPost(post_id)).subscribe(data=>{
      this.random = data[0];
      this.blogPost=data[1];
      this.loading = false;
      this.thisPage=this.blogPost.title;
     })
  }
}
